import { LeftArrowIcon, RightArrowIcon } from '@sketchnote/icons';
import { Progress } from '@sketchnote/shared-components';
import cn from 'classnames';
import * as React from 'react';

import { NavigtionButton } from '../../button/nav-button.component';

const { useState, useRef, useEffect } = React;

export const LearningProgress = ({
  current,
  total,
  onChangeNavigation,
  onGoBack,
  disabled,
  className = '',
}: {
  current: number;
  total: number;
  onChangeNavigation: (newCurrent: 'back' | 'front') => void;
  onGoBack: (index: number) => void;
  disabled: {
    right: boolean;
    left: boolean;
  };
  className?: string;
}) => {
  const [thumbWidth, setThumbWidth] = useState(0);
  const [completedWidth, setCompletedWidth] = useState(0);
  const barRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const completedProgressWidth = ((barRef.current?.clientWidth || 0) / total) * current;
    setCompletedWidth(completedProgressWidth);
    setThumbWidth(completedProgressWidth / current);
  }, [current, total]);
  return (
    <div
      className={cn('border-t bg-white border-gray-200 px-36 py-8 w-full z-50 bottom-0', {
        [className]: !!className,
      })}
    >
      <div className="flex items-center">
        <NavigtionButton
          icon={LeftArrowIcon}
          disabled={disabled.left}
          onClick={onChangeNavigation.bind(this, 'back')}
        />
        <NavigtionButton
          icon={RightArrowIcon}
          disabled={disabled.right}
          onClick={onChangeNavigation.bind(this, 'front')}
        />
        {current !== undefined && total !== undefined ? (
          <div className="mr-24 text-gray-500 font-medium">
            {current}/{total}
          </div>
        ) : null}
        <Progress.Wrapper>
          <Progress.Bar
            barProps={{ ref: barRef }}
            progressedProps={{
              style: { width: completedWidth, transition: 'width 0.5s linear' },
            }}
            value={0}
          />
          <div className="h-4 absolute left-0 flex">
            {Array(current)
              .fill('progress')
              .map((obj, index) => (
                <ProgressThumb
                  key={`${obj}-${index}`}
                  thumbWidth={thumbWidth}
                  total={total}
                  current={index + 1}
                  onClick={onGoBack.bind(this, index)}
                />
              ))}
          </div>
        </Progress.Wrapper>
      </div>
    </div>
  );
};

const ProgressThumb = ({ thumbWidth, total, current, onClick }: any) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [positions, setPositions] = useState<any>([0, 0]);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const leftValue = (ref.current?.clientWidth || 0) / 2 - 30;
    setPositions([leftValue, ref.current?.offsetTop]);
  }, [thumbWidth]);
  const handleVisible = (visible: boolean) => {
    setIsVisible(visible);
  };
  return (
    <div
      className={`relative transition-all duration-200 -top-4 z-10 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
      onClick={onClick}
    >
      <span
        style={{ left: positions[0], top: -45 }}
        className="bg-gray-999 rounded text-white p-8 text-xss font-medium absolute w-45 h-35"
      >
        {`${current} / ${total}`}
      </span>
      <div
        className="bg-primary-200 cursor-pointer h-4 rounded"
        style={{ width: thumbWidth }}
        ref={ref}
        onMouseEnter={handleVisible.bind(this, true)}
        onMouseLeave={handleVisible.bind(this, false)}
      />
    </div>
  );
};
